import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSwitch } from "../context/SwitchContext";
import EN from "../locales/en";
import Button from "./Button";

const SwitchNowButton = ({ quote }) => {
  const navigate = useNavigate();
  const { mpan, mprn } = useParams();
  const { setSelectedSwitchTariff } = useSwitch();

  const goToSwitch = () => {
    setSelectedSwitchTariff(quote);

    navigate(`/switch/${quote?.priceId}/${mpan}/${mprn}`, {
      state: { currentPage: 1 },
    });
  };

  return <Button onClick={goToSwitch}>{EN.quotes.switch_now_text}</Button>;
};

export default SwitchNowButton;
